import React from 'react';
import { withRouter } from "react-router-dom";
import { Typography } from "../../ecosystem";
import { DashboardTile } from '../DashboardTile';

const NoAppointmentsTile = ({
    disabled = false,
    isMobile
}) => {

    return (<DashboardTile
        className="appt-refresh-tile"
        disabled={disabled}
    >
        <div className="col-12 appt-tile-body">
            <Typography type="body-02" tag="div" color={disabled ? "$color-secondary-a4" : "$color-primary-a2"} textAlign="center">
                You have no appointments at this time.
            </Typography>
        </div>
    </DashboardTile>);
}

export default withRouter(NoAppointmentsTile);
